<div>
  <ul class="list-inline rating-list"
      *ngFor="let star of stars" style="display: inline-block">
    <li (click)="countStar(star)"
        [ngClass]="{'selected': (star <= selectedValue)}">
      <fa-icon [icon]="faStar"></fa-icon>
    </li>
  </ul>
</div>
